import React from "react";
import {
  Container,
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  DatePicker,
  FormSelect,
  FormInput,
  Button,
  Form,
} from "shards-react";
import moment from "moment";
import {actions as AppActions} from "../../_stores/app.store";
import SupplierService from "../../services/supplier.service";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { Link } from "react-router-dom";
import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus, FcDownload } from "react-icons/fc";
import authStore from "../../_stores/auth.store";
import * as XLSX from "xlsx";
import ReportService from "../../services/report.service";
import ConversionDataService from "../../services/conversions.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const perPage = 10;
const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

const date = new Date();
const currentyear = date.getUTCFullYear();
let YEAR = [];
YEAR.push(currentyear-3);
YEAR.push(currentyear-2);
YEAR.push(currentyear-1);
YEAR.push(currentyear);
YEAR.push(currentyear+1);
YEAR.push(currentyear+2);

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

class ViewReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ERPList: [],
      supplierList: [],
      filteredSupplierList: [],
      erpSupplierList: [],
      selectedERP: '',
      selectedSupplier: null,
      searchQuery: '',
      productCode: '',
      isConversionFound: false,
      conversionsListOrg: [],
      conversionsList: [],
      uploadReady: false,
      selectedConversion: false,
      yearList: YEAR,
      monthList: MONTHS,
      selectedMonth: "",
      dateFrom: null,
      dateTo: null,
      apiSuccessMessage: "",
      apiErrorMessage: "",
    };
    this.onChangeERP = this.onChangeERP.bind(this);
    this.onChangeSupplierName = this.onChangeSupplierName.bind(this);
    this.onChangeConversion = this.onChangeConversion.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onChangeProductCode = this.onChangeProductCode.bind(this);
    this.onChangeIsConversionFound = this.onChangeIsConversionFound.bind(this);
    this.getTableData = this.getTableData.bind(this);
    this.saveTableData = this.saveTableData.bind(this);
    this.onFileChanged = this.onFileChanged.bind(this);
    this.handleBulkUpload = this.handleBulkUpload.bind(this);

    this.aggridRef = React.createRef();
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
    this.exportConversionsToExcel = this.exportConversionsToExcel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.isOptionDisabled = this.isOptionDisabled.bind(this);
    this.dateChanged = this.dateChanged.bind(this);
    this.getSupplierFromList = this.getSupplierFromList.bind(this);
  }

  componentDidMount() {
    //console.log("this.props", this.props);
    this.fetchSuppliers();
  }

  componentDidUpdate(prevProps) {}

  
  fetchSuppliers() {
    AppActions.setLoading(true);
    SupplierService.getAll().then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length);
        const supplierERP = this.getUniqueERP(response.data.data);
        supplierERP.sort((a, b) => a.supplierERP.localeCompare(b.supplierERP));
        //console.log("supplierERP", supplierERP);
        this.setState({
          supplierList: response.data.data,
          ERPList: supplierERP
        });

        if(this.props.viewProps.match.params.suppliercode){
          const supplierCode = this.props.viewProps.match.params.suppliercode;
          // console.log("fetchSuppliers.this.props", this.props.viewProps.match);
          // console.log("fetchSuppliers.suppliercode", supplierCode);
          const supplier = this.getSupplierFromList(response.data.data, supplierCode);
          //console.log("fetchSuppliers.supplier", supplier);
          if(supplier){
            const filteredSuppliers = response.data.data.filter((item) => item.supplierERP === supplier.supplierERP);
            //console.log("fetchSuppliers.filteredSuppliers", filteredSuppliers);
            const options = filteredSuppliers.map(item => ({
              value: item.supplierCode,
              label: `${item.supplierCode} - ${item.supplierName}`
            }));

            const selectedOptions = {
              value: supplier.supplierCode,
              label: `${supplier.supplierCode} - ${supplier.supplierName}`
            };
        
            options.unshift({value: 'all', label: 'ALL'});
            this.setState({
              selectedERP: supplier.supplierERP,
              filteredSupplierList: filteredSuppliers,
              erpSupplierList: options,
              selectedSupplier: [selectedOptions],
            }, () => {
              this.getTableData();
            });

            
          }
        }
    });
  }

  getSupplierFromList(supplierList, supplierCode) {
    //console.log("fetchSuppliers.supplierList", supplierList);
    const supplier = supplierList.filter(x => x.supplierCode === supplierCode);
    return (supplier && supplier[0]) || {};
  }

  getUniqueERP(supplierList) {
    const uniqueSupplierERP = [];
    // Create a Set to store unique ERP values
    const uniqueERPSet = new Set();

    // Iterate through the supplier array to collect unique ERP values
    supplierList.forEach((item) => {
      if (!uniqueERPSet.has(item.supplierERP)) {
        uniqueERPSet.add(item.supplierERP);
        uniqueSupplierERP.push({
          id: item.id,
          supplierCode: item.supplierCode,
          supplierERP: item.supplierERP,
        });
      }
    });
    
    return uniqueSupplierERP
    
  }

  dateChanged(dVal, dKey) {
    this.setState({ [dKey]: dVal });
  }


  onChangeERP(evt) {
    //this.setState({ filteredSupplierList: [] });
    //this.filterSupplier(evt.target.value);

    const selectedERP = evt.target.value;
    console.log("selectedERP", selectedERP);

    // Filter the supplierList based on the selected ERP
    const filteredSuppliers = this.state.supplierList.filter((item) => item.supplierERP === selectedERP);
    console.log("filteredSuppliers", filteredSuppliers);

    const options = filteredSuppliers.map(item => ({
      value: item.supplierCode,
      label: `${item.supplierCode} - ${item.supplierName}`
    }));

    options.unshift({value: 'all', label: 'ALL'});


    this.setState({ 
      selectedERP: evt.target.value, 
      selectedSupplier: null, 
      filteredSupplierList: filteredSuppliers,
      erpSupplierList: options,
      searchQuery: '', // Reset search query when ERP changes
    });
  }


  // filterSupplier(selectedERP) {
  //   const filteredSuppliers = this.state.supplierList.filter((item) => item.supplierERP === selectedERP);
  //   console.log("filteredSuppliers", filteredSuppliers);
  //   this.setState({ filteredSupplierList: filteredSuppliers });
    
  // }

  onChangeSupplierName(evt) {
    this.setState({ selectedSupplier: evt.target.value });
  }

  onChangeConversion(evt) {
    console.log('onChangeConversion', evt.target.value);
    this.setState({ selectedConversion: evt.target.value });
  }

  onSearchChange = (event) => {
    // const searchQuery = event.target.value.toLowerCase();
    // // Filter the supplier list based on the search query
    // const filteredSupplierList = this.state.supplierList.filter((supplier) =>
    //   supplier.supplierName.toLowerCase().includes(searchQuery)
    // );

    // this.setState({
    //   filteredSupplierList,
    //   searchQuery,
    // });
  };

  onChangeProductCode = (evt) => {
    this.setState({ productCode: evt.target.value });
  }

  onChangeIsConversionFound = (value) => {
    this.setState({ isConversionFound: value });
  }

  saveTableData = () => {
    this.clearMessage();
    AppActions.setLoading(true);
    console.log('saveTableData');

    const { conversionsList, conversionsListOrg } = this.state;

    console.log('saveTableData.conversionsList', conversionsList);

    const newArray = [];

    conversionsListOrg.forEach((obj1, index) => {
        const obj2 = conversionsList[index];
        console.log('saveTableData.obj2', obj2);
        if (obj1.uniquekey == obj2.uniquekey && (obj1.Conversion !== obj2.Conversion || obj2.update)) {
            const diffObj = {
                ...obj2,
                Conversion: obj2.Conversion
            };
            newArray.push(diffObj);
        }
    });


    //console.log('saveTableData.conversionsList', conversionsList);
    console.log('saveTableData.newArray', newArray);

    if(newArray){
      ConversionDataService.bulkCreate({ bulkData: newArray }).then((response) => {
        AppActions.setLoading(false);
      
        if (response.data.success) {
          var notify_message = {
            type: "success",
            message: "Conversions uploaded successfully.",
          };
          this.setState({ apiSuccessMessage: "Conversions uploaded successfully." });
          this.notify(notify_message.type, notify_message.message);
        } else {
          var notify_message = {
            type: "error",
            message: response.data.message,
          };
          this.setState({ apiErrorMessage: response.data.message });
          this.notify(notify_message.type, notify_message.message);
        }
      });

   } else {
      var notify_message = {
        type: "error",
        message: "No Data to save",
      };
      this.notify(notify_message.type, notify_message.message);
   }
    
  }

  getTableData = () => {
    this.clearMessage();
    AppActions.setLoading(true);
    console.log('getTableData');
    this.setState({ conversionsList: [] });

    let supplierArray = [];

    const {
      selectedSupplier,
      productCode,
      isConversionFound,
      selectedConversion,
      selectedERP,
      erpSupplierList,
      selectedYear,
      selectedMonth,
      dateFrom,
      dateTo,
      ERPList,
      supplierList
    } = this.state;

    erpSupplierList.shift();

    supplierArray = selectedSupplier;

    if(
      selectedSupplier &&
      selectedSupplier.some((supplier) => supplier.value === "all")
    ) {
      supplierArray = erpSupplierList;
    }

    const queryObj = {
      projectId: this.props.projectId,
      supplierCode: supplierArray,
      productCode: productCode,
      isConversionFound: selectedConversion,
      year: selectedYear,
      month: selectedMonth,
      dateFrom: dateFrom,
      dateTo: dateTo
    };

    ReportService.getTableData(queryObj).then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length > 0) {
        const conversionsListArray = JSON.parse(JSON.stringify(response.data.data));
        const conversionsListOrgArray = JSON.parse(JSON.stringify(response.data.data));
        

        conversionsListArray.forEach(conversion => {
          const supplier = supplierList.find(s => s.supplierCode == conversion.supplierCode);
          //console.log('getTableData.supplier', supplier);
          if (supplier) {
            conversion.erpName = supplier.supplierERP;
          }
        });

        conversionsListOrgArray.forEach(conversion => {
          const supplier = supplierList.find(s => s.supplierCode == conversion.supplierCode);
          //console.log('getTableData.supplier', supplier);
          if (supplier) {
            conversion.erpName = supplier.supplierERP;
          }
        });

        // const conversionsList = conversionsListArray.map(v => ({...v, erpName: this.state.selectedERP }));
        // const conversionsListOrg = conversionsListOrgArray.map(v => ({...v, erpName: this.state.selectedERP }));

        this.setState({ 
          conversionsList: conversionsListArray,
          conversionsListOrg: conversionsListOrgArray
        });
      }
    });
  }

  exportConversionsToExcel(type) {
    this.clearMessage();
    const { conversionsList } = this.state;
    const sheetdata = [];
    sheetdata.push(["Batch Id", "Retailer ID", "ERP Name", "Company Name", "Product Code", "Product Name", "UOM", "Conversion", "Opening Stk", "Receipt", "Sales Qty", "Closing Stk", "PURCHASE RATE", "MRP", "Conversion Found", "Unique Key" ]);
    for (let i = 0; i < conversionsList.length; i++) {
      const conItem = conversionsList[i];
      sheetdata.push([conItem.batchId, conItem.supplierCode, conItem.erpName, conItem.COMPANY_NAME, conItem.PROD_CODE, conItem.PRODUCT_NAME, conItem.UOM, conItem.Conversion, conItem.OPENING_STOCK, conItem.GOODS_RECEIVED, conItem.SALES_QTY, conItem.CLOSING_STOCK, conItem.PUR_RATE, conItem.MRP, conItem.isConversionFound, conItem.uniquekey]);
    }
    this.prepWorkbookFromJson(sheetdata);
  }

  prepWorkbookFromJson(sheetdata) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer);
  }

  createUrlFromBlob(bufferData) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFile(objurl, "conversion_factor_master_" + new Date().getTime() + EXCEL_EXTENSION);
    URL.revokeObjectURL(objurl);
  }

  downloadFile(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  onChangeFilteredColumnValue(e){
    this.setState({ filteredColumnValue: e.target.value});
  }

  onFileChanged(evt) {
    AppActions.setLoading(true);
    const { target } = evt;
    let file = null;

    if (target.files && target.files.length) {
      file = target.files[0];
    }
    this.readFileData(file);
  }

  async readFileData(file) {
    const reader = new FileReader();
    if (reader.readAsBinaryString) {
      reader.onload = async (e) => {
        this.extractExcelData(reader.result);
      };
      reader.readAsBinaryString(file);
    }
  }

  extractExcelData(data) {
    const workbook = XLSX.read(data, {
      type: "binary",
    });
    const sheet01 = workbook.Sheets[workbook.SheetNames[0]];
    const sheetdata = XLSX.utils.sheet_to_json(sheet01, {
      header: 1,
    });
    console.log('extractExcelData.sheetdata', sheetdata);
    sheetdata.splice(0, 1);
    if (sheetdata.length && sheetdata[0].length)
      this.setState({
        excelRows: sheetdata,
        uploadReady: true,
      });
    else this.notify("error", "No data found in the sheet");
    AppActions.setLoading(false);
  }

  handleBulkUpload() {
    this.clearMessage();
    const { excelRows } = this.state;
    console.log('handleBulkUpload.excelRows', excelRows);
    const bulkData = excelRows.map((row) => ({
      batchId: row[0],
      supplierCode: row[1],
      erpName: row[2],
      COMPANY_NAME: row[3],
      PROD_CODE: row[4],
      PRODUCT_NAME: row[5],
      UOM: row[6],
      Conversion: row[7],
      // OPENING_STOCK: row[8],
      // GOODS_RECEIVED: row[9],
      // SALES_QTY: row[10],
      // CLOSING_STOCK: row[11],
      isConversionFound: row[14],
      uniquekey: row[15]
    }));

    AppActions.setLoading(true);
    ConversionDataService.bulkCreate({ bulkData }).then((response) => {
      AppActions.setLoading(false);
     
      if (response.data.success) {
        var notify_message = {
          type: "success",
          message: response.data.data,
        };
        this.setState({ apiSuccessMessage: response.data.data });
        this.notify(notify_message.type, notify_message.message);
      } else {
        var notify_message = {
          type: "error",
          message: response.data.message,
        };
        this.setState({ apiErrorMessage: response.data.message });
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  handleChange(selectedOption) {

    console.log(`handleChange Option selected:`, selectedOption);


    this.setState({ selectedSupplier: selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedSupplier)
    );
  };

  isOptionDisabled = (option) => {
    const { selectedSupplier } = this.state;
    return (
      selectedSupplier &&
      selectedSupplier.some((supplier) => supplier.value === "all") &&
      option.value !== "all"
    );
    //return selectedSupplier && selectedSupplier[0] && selectedSupplier[0].value === "all" && option.value !== "all";
  };

  updateConversionBtn(checked, data) {
    const { conversionsList } = this.state;
    console.log('updateConversionBtn.checked', checked);
    console.log('updateConversionBtn.data', data);

    conversionsList.forEach((obj1, index) => {
        if (obj1.uniquekey == data.uniquekey && checked) {
          obj1.update = true;
        } else if (obj1.uniquekey == data.uniquekey && !checked) {
          obj1.update = false;
        }
    });
  }

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  clearMessage() {
    this.setState({ apiSuccessMessage: "", apiErrorMessage: "" });
  }

  ToggleRenderer = ({ value, onToggle, data }) => {
    return (
      <input
        type="checkbox"
        checked={value}
        onChange={(e) => this.updateConversionBtn(e.target.checked, data)}
      />
    );
  };


  render() {
    const {
      ERPList,
      supplierList,
      selectedERP,
      selectedSupplier,
      filteredSupplierList,
      erpSupplierList,
      searchQuery,
      productCode,
      isConversionFound,
      uploadReady,
      selectedConversion,
      selectedYear,
      yearList,
      selectedMonth,
      monthList,
      dateFrom,
      dateTo,
    } = this.state;

    const { conversionsList, conversionsList_paged, filteredColumn, filteredColumnValue } = this.state;
    const isDisabled = ((filteredColumn === '' || filteredColumn === 0 || filteredColumn === null) 
          || (filteredColumnValue === '' || filteredColumnValue === null || filteredColumnValue === 0 ));
    const columnDefs = [
      {headerName: "Batch Id", field: "batchId", filter: true, sortable:true, unSortIcon:true },
      {headerName: "ERP Name", field: "erpName", filter: true, sortable:true, unSortIcon:true, width:"150" },
      {headerName: "Retailer ID", field: "supplierCode", filter: true, sortable:true, unSortIcon:true, width:"150" },
      {headerName: "Company Name", field: "COMPANY_NAME",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Product Code", field: "PROD_CODE",filter: true, sortable:true, unSortIcon:true, width:"150" },
      {headerName: "Product Name", field: "PRODUCT_NAME",filter: true, sortable:true, unSortIcon:true},
      {headerName: "UOM", field: "UOM",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "Conversion", field: "Conversion",filter: true, sortable:true, unSortIcon:true, editable: true, width:"150"},
      {headerName: "Opening Stk", field: "OPENING_STOCK",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "Receipt", field: "GOODS_RECEIVED",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "Sales Qty", field: "SALES_QTY",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "Closing Stk", field: "CLOSING_STOCK",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "PURCHASE RATE", field: "PUR_RATE",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "MRP", field: "MRP",filter: true, sortable:true, unSortIcon:true, width:"150"},
      {headerName: "Conversion Found", field: "isConversionFound",filter: true,  sortable:true, width:"150",
          cellRendererFramework: (data) => {
            return data.value === '1' ? 'YES' : 'NO'
          } 
      },
      {headerName: "Unique Key", field: "uniquekey",filter: true, sortable:true, width:"250", unSortIcon:true, editable: true},
      {headerName: "Updated At", field: "updatedDate",filter: true,  sortable:true, width:"150",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "update conversion", field:"id", width:"150",
        cellRendererFramework: this.ToggleRenderer
        // cellRendererFramework: (data) => {
        //   // return <>
        //   //   {/* <Link title="Details" className="text-primary mr-2" to={"/conversion/"+data.value+"/details"}><TiEyeOutline  size="20" /></Link>
        //   //   <Link title="Edit" className="text-success mr-2" to={"/conversion/"+data.value+"/edit"}><TiEdit  size="20" /></Link> */}
        //   //   {authStore.getState().auth_reducer.user.role === "superadmin" && (
        //   //     <span className="text-danger cursor-pointer" title="delete" onClick={() => this.updateConversionBtn(data.data)}><TiDeleteOutline size="20" /></span>
        //   //   )}
        //   // </>
        //   <input
        //     type="checkbox"
        //     checked={value}
        //     onChange={(e) => this.updateConversionBtn(e.target.checked, data.data)}
        //   />
        // }
      }
    ]

    


    return (
      <>
        <Row>
          <Col>
            <Card small>
              <CardHeader className="border-bottom">
              <Row>
                <Col md="5" className="mb-0">
                  <h6>
                    Conversions List
                    
                    
                  </h6>
                  </Col>
                <Col md="7" className="mb-0" >
                  <Form>
                      <Row form>
                        <Col className="form-group">
                          <Row className="form-group-row">
                            <Col className="form-label" md="4">
                              <label htmlFor="">Upload Conversion File</label>
                            </Col>
                            <Col className="form-field" md="4">
                              <div className="file-ctrl-wrap">
                                <input
                                  type="file"
                                  className="file-input"
                                  id="file"
                                  name="file"
                                  placeholder="Browse excel file to upload"
                                  onChange={this.onFileChanged}
                                />
                              </div>
                            </Col>
                          
                          {uploadReady ? (
                            
                              <Col className="form-button" md="4">
                                <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleBulkUpload}>
                                  <FcPlus /> Upload Conversion Data
                                </Button>
                              </Col>
                           
                          ) : (
                            <></>
                          )}
                          </Row>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </CardHeader>

              <CardHeader className="border-bottom">
                <Row>
                  <Col md="12" className="mb-3">
                    <Row>
                      <Col md="4" className="flx-dir-col">
                        <label className="mb-0">Select ERP</label>
                        <FormSelect
                          id="erp-select"
                          onChange={this.onChangeERP}
                          value={selectedERP}
                        >
                          <option value={0}>Select</option>
                          {ERPList.map((erp) => (
                            <option key={erp.supplierERP} value={erp.supplierERP}>
                              {erp.supplierERP}
                            </option>
                          ))}
                        </FormSelect>
                      </Col>
                      <Col md="3">
                        <label className="mb-0">From Date</label>
                        <DatePicker
                          selected={dateFrom}
                          onChange={(dt) => this.dateChanged(dt, "dateFrom")}
                          placeholderText="Select"
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                        />
                      </Col>
                      <Col md="3">
                        <label className="mb-0">To Date</label>
                        <DatePicker
                          selected={dateTo}
                          onChange={(dt) => this.dateChanged(dt, "dateTo")}
                          placeholderText="Select"
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                        />
                      </Col>
                      <Col md="2" className="mt-4">
                          <button
                            className="btn btn-primary mt-auto"
                            onClick={this.getTableData}
                          >
                            Get Data
                          </button>
                      </Col>
                      
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" className="mb-3">
                    <Row>
                      {filteredSupplierList && filteredSupplierList.length > 0 && (
                        <Col md="5">
                          <label className="mb-0">Select Supplier</label>
                          <Select
                            value={selectedSupplier}
                            onChange={this.handleChange}
                            options={erpSupplierList}
                            isMulti={true}
                            isOptionDisabled={this.isOptionDisabled}
                          />
                        </Col>
                      )}
                      {selectedSupplier && (
                        <>
                          <Col md="2">
                              <label className="mb-0">Conversion</label>
                              <Row>
                                <Col md="12" className="flx-dir-col">
                                  <FormSelect
                                    id="isConversionFound"
                                    onChange={this.onChangeConversion}
                                    value={selectedConversion}
                                  >
                                    <option value={0}>Select</option>
                                    <option value="all">All</option>
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                                  </FormSelect>
                                </Col>
                              </Row>
                          </Col>
                            
                          </>
                        )}
                      
                      <Col md="auto" className="mt-4">
                        {this.state.apiSuccessMessage && (<span className="success">{this.state.apiSuccessMessage}</span>)}
                        {this.state.apiErrorMessage && (<span className="error">{this.state.apiErrorMessage}</span>)}
                      </Col>
                      </Row> 
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                  <Row>
                    <Col md="3">
                      <div className="example-header">
                        Page Size: &nbsp;
                        <select onChange={this.onPageSizeChanged} id="page-size">
                          <option value="10" selected={true}>
                            10
                          </option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                      </div>
                    </Col>

                    
                    <Col md="4" className="mb-2 mt-2">
                      <div>
                        <Button variant="primary" className="ml-3 btn btn-success" onClick={() => this.exportConversionsToExcel()}>
                          <FcDownload /> Export Conversion Data
                        </Button>
                      </div>
                    </Col>

                    <Col md="4" className="mb-2 mt-2">
                      <div>
                        <button
                          className="btn btn-primary mt-auto"
                          onClick={this.saveTableData}
                        >
                          Save Data
                        </button>
                      </div>
                    </Col>
                  </Row>
                  
                  
                  <AgGridReact
                      ref={this.aggridRef}
                      pagination={true}
                      rowHeight={50}
                      paginationPageSize={perPage}
                      columnDefs={columnDefs}
                      rowData={conversionsList}
                  >
                  </AgGridReact>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        

  

  
      </>
    );
  }
}

export default ViewReport;
